import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-vote",
  templateUrl: "./vote.component.html",
  styleUrls: ["./vote.component.css"],
  standalone: false
})
export class VoteComponent implements OnInit {
  @Output() closeVotePopup = new EventEmitter<void>();
  safeUrl: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://ciscochannels.qualtrics.com/jfe/form/SV_3z1AHOdq3scT4Ca');
  }

  onClickClose() {
    this.closeVotePopup.emit();
  }
}
